import { ScaleInfo } from "custom-models/ViewerTypes";

const BASE_COLOR = "var(--richBlack)";

const SectionBBox = ({
  bbox,
  scaleInfo,
  pixelsPerMeter,
}: {
  bbox: [number, number, number, number];
  scaleInfo: ScaleInfo;
  pixelsPerMeter: number;
}) => {
  const [x1, y1, x2, y2] = bbox;
  const scale = (scaleInfo.scaleX + scaleInfo.scaleY) / 2;

  const width = x2 - x1;
  const height = y2 - y1;

  return (
    <rect
      x={x1}
      y={y1}
      width={width}
      height={height}
      fill="none"
      stroke="var(--green)"
      strokeWidth={0.75 / scale}
    />
  );
};

export default SectionBBox;
